







































import { Vue, Component, Prop, Watch } from "vue-property-decorator";

// Enums/Data
import {
  ProvisionFieldTypes,
  BlueprintFieldsTypes
} from "@/data/enums/provisioning";
import { ProductTypes } from "@/data/enums/products";

// Types
import { IProduct } from "@/models/products";
import { IBlueprintField } from "@/models/provisioning";

@Component({
  components: {
    "provision-field": () =>
      import(
        "@/components/app/admin/catalogue/products/provisioning/provisionField.vue"
      )
  }
})
export default class ConfigureField extends Vue {
  @Prop({ default: null })
  public value!: any;

  @Prop({ required: true })
  public product!: IProduct;

  @Prop({ required: true })
  public field!: IBlueprintField;

  @Prop({ required: true })
  public fieldId!: string;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: ProvisionFieldTypes.PRODUCT_FIELD })
  public type!: ProvisionFieldTypes;

  @Prop({ default: true })
  public showFieldCheckbox!: boolean;

  public configureField = false;
  public initialValue = null;
  public savedFieldValue = null;

  public get fieldValue() {
    return this.value;
  }

  public set fieldValue(value) {
    const newFieldValue = this.showFieldCheckbox
      ? value
      : value === ""
      ? null
      : value;

    this.$emit("input", newFieldValue);
  }

  public created() {
    if (this.fieldValue === null) {
      return;
    }

    this.initialValue = this.fieldValue;
    this.configureField = true;
  }

  public get isAttribute() {
    return (
      this.$_.get(this.product, "product_type") ===
      ProductTypes.PRODUCT_ATTRIBUTE
    );
  }

  public get isOption() {
    return (
      this.$_.get(this.product, "product_type") === ProductTypes.PRODUCT_OPTION
    );
  }

  public get productTypeLabel() {
    return `${
      this.isOption
        ? this.$t("_.option")
        : this.isAttribute
        ? this.$t("_.attribute")
        : this.$t("_.product")
    }: ${
      this.isAttribute || this.isOption
        ? `${this.$_.get(this.product, "category.name_translated", "")} / `
        : ``
    }`;
  }

  @Watch("configureField")
  public onConfigureFieldChange() {
    if (!this.configureField) {
      this.savedFieldValue =
        this.fieldValue === this.initialValue ? null : this.fieldValue;

      this.$emit("input", null);
      return;
    }

    this.$emit(
      "input",
      this.savedFieldValue !== null
        ? this.savedFieldValue
        : this.field.field_type === BlueprintFieldsTypes.CHECKBOX &&
          this.initialValue === null
        ? false
        : this.initialValue
    );
  }
}
